// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
margin: 0;
font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
sans-serif;
-webkit-font-smoothing: antialiased;
-moz-osx-font-smoothing: grayscale;
background-color: #f5f7fa;
}

code {
font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
monospace;
}

#root {
min-height: 100vh;
}

@media (max-width: 700px) {
  .repository-header-content {
    display: grid !important;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: center !important;
    gap: 14px 12px !important;
    padding: 0 16px !important;
  }

  .repository-brand {
    grid-column: 1 / -1;
    justify-self: start;
    width: 100%;
  }

  .repository-logo-text {
    min-width: 0;
    white-space: nowrap;
    font-size: clamp(21px, 6.5vw, 28px) !important;
  }

  .repository-search {
    grid-column: 1;
    min-width: 0;
    width: 100%;
    max-width: none !important;
  }

  .repository-search-input {
    min-width: 0;
    width: 100%;
    box-sizing: border-box;
  }

  .repository-login-button {
    grid-column: 2;
    white-space: nowrap;
  }
}

@media (max-width: 430px) {
  .repository-header-content {
    gap: 12px 8px !important;
    padding: 0 12px !important;
  }

  .repository-search {
    gap: 6px !important;
  }

  .repository-search button,
  .repository-login-button {
    padding-left: 14px !important;
    padding-right: 14px !important;
  }
}

/* Scrollbar Styling */
::-webkit-scrollbar {
width: 10px;
height: 10px;
}

::-webkit-scrollbar-track {
background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
background: #888;
border-radius: 5px;
}

::-webkit-scrollbar-thumb:hover {
background: #555;
}

/* Global Resets */

- {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  }

/* Links */
a {
color: #667eea;
text-decoration: none;
transition: color 0.2s;
}

a:hover {
color: #764ba2;
text-decoration: underline;
}

/* Buttons */
button {
font-family: inherit;
cursor: pointer;
transition: all 0.2s;
}

button:hover:not(:disabled) {
opacity: 0.9;
transform: translateY(-1px);
}

button:active:not(:disabled) {
transform: translateY(0);
}

button:disabled {
opacity: 0.6;
cursor: not-allowed;
}

/* Inputs */
input,
textarea,
select {
font-family: inherit;
font-size: 14px;
}

input:focus,
textarea:focus,
select:focus {
outline: none;
border-color: #667eea;
box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

/* Utility Classes */
.container {
max-width: 1400px;
margin: 0 auto;
padding: 20px;
}

.text-center {
text-align: center;
}

.text-left {
text-align: left;
}

.text-right {
text-align: right;
}

/* Spacing Utilities */
.mt-1 { margin-top: 8px; }
.mt-2 { margin-top: 16px; }
.mt-3 { margin-top: 24px; }
.mt-4 { margin-top: 32px; }
.mt-5 { margin-top: 40px; }

.mb-1 { margin-bottom: 8px; }
.mb-2 { margin-bottom: 16px; }
.mb-3 { margin-bottom: 24px; }
.mb-4 { margin-bottom: 32px; }
.mb-5 { margin-bottom: 40px; }

.ml-1 { margin-left: 8px; }
.ml-2 { margin-left: 16px; }
.ml-3 { margin-left: 24px; }

.mr-1 { margin-right: 8px; }
.mr-2 { margin-right: 16px; }
.mr-3 { margin-right: 24px; }

.p-1 { padding: 8px; }
.p-2 { padding: 16px; }
.p-3 { padding: 24px; }
.p-4 { padding: 32px; }

.pt-1 { padding-top: 8px; }
.pt-2 { padding-top: 16px; }
.pt-3 { padding-top: 24px; }

.pb-1 { padding-bottom: 8px; }
.pb-2 { padding-bottom: 16px; }
.pb-3 { padding-bottom: 24px; }

/* Flexbox Utilities */
.flex {
display: flex;
}

.flex-col {
flex-direction: column;
}

.flex-row {
flex-direction: row;
}

.items-center {
align-items: center;
}

.items-start {
align-items: flex-start;
}

.items-end {
align-items: flex-end;
}

.justify-center {
justify-content: center;
}

.justify-between {
justify-content: space-between;
}

.justify-around {
justify-content: space-around;
}

.justify-start {
justify-content: flex-start;
}

.justify-end {
justify-content: flex-end;
}

.flex-wrap {
flex-wrap: wrap;
}

.flex-1 {
flex: 1 1;
}

.gap-1 { gap: 8px; }
.gap-2 { gap: 16px; }
.gap-3 { gap: 24px; }
.gap-4 { gap: 32px; }

/* Width & Height */
.w-full {
width: 100%;
}

.h-full {
height: 100%;
}

.w-auto {
width: auto;
}

.h-auto {
height: auto;
}

/* Display */
.block {
display: block;
}

.inline-block {
display: inline-block;
}

.hidden {
display: none;
}

/* Position */
.relative {
position: relative;
}

.absolute {
position: absolute;
}

.fixed {
position: fixed;
}

/* Overflow */
.overflow-auto {
overflow: auto;
}

.overflow-hidden {
overflow: hidden;
}

/* Border Radius */
.rounded {
border-radius: 4px;
}

.rounded-lg {
border-radius: 8px;
}

.rounded-xl {
border-radius: 12px;
}

.rounded-full {
border-radius: 9999px;
}

/* Shadows */
.shadow-sm {
box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.shadow {
box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.shadow-md {
box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.shadow-lg {
box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1);
}

/* Text */
.font-bold {
font-weight: bold;
}

.font-semibold {
font-weight: 600;
}

.font-normal {
font-weight: normal;
}

.text-sm {
font-size: 14px;
}

.text-base {
font-size: 16px;
}

.text-lg {
font-size: 18px;
}

.text-xl {
font-size: 20px;
}

.text-2xl {
font-size: 24px;
}

/* Colors */
.text-primary {
color: #667eea;
}

.text-secondary {
color: #764ba2;
}

.text-gray {
color: #666;
}

.text-dark {
color: #333;
}

.text-white {
color: #fff;
}

.bg-primary {
background-color: #667eea;
}

.bg-secondary {
background-color: #764ba2;
}

.bg-white {
background-color: #fff;
}

.bg-gray-light {
background-color: #f8f9fa;
}

/* Animations */
@keyframes fadeIn {
from {
opacity: 0;
}
to {
opacity: 1;
}
}

@keyframes slideIn {
from {
transform: translateY(20px);
opacity: 0;
}
to {
transform: translateY(0);
opacity: 1;
}
}

.fade-in {
animation: fadeIn 0.3s ease-in;
}

.slide-in {
animation: slideIn 0.3s ease-out;
}

/* Loading Spinner */
.spinner {
border: 4px solid #f3f3f3;
border-top: 4px solid #667eea;
border-radius: 50%;
width: 40px;
height: 40px;
animation: spin 1s linear infinite;
}

@keyframes spin {
0% { transform: rotate(0deg); }
100% { transform: rotate(360deg); }
}

/* Responsive */
@media (max-width: 768px) {
.container {
padding: 10px;
}

.plugin-detail-header {
padding: 16px !important;
}

.plugin-detail-hero {
padding: 24px 16px !important;
}

.plugin-detail-hero-content {
display: flex !important;
flex-direction: column !important;
gap: 24px !important;
width: 100% !important;
}

.plugin-detail-actions {
width: 100% !important;
min-width: 0 !important;
}

.plugin-detail-actions button {
box-sizing: border-box;
}

.plugin-detail-gallery {
padding: 20px 0 !important;
grid-template-columns: minmax(0, 1fr) !important;
}

.plugin-detail-tabs {
width: 100% !important;
max-width: none !important;
box-sizing: border-box;
padding: 0 !important;
gap: 0 !important;
overflow-x: auto;
scrollbar-width: thin;
}

.plugin-detail-tabs > button {
flex: 1 0 auto;
padding: 14px 18px !important;
white-space: nowrap;
}

.plugin-detail-content {
width: 100% !important;
max-width: none !important;
box-sizing: border-box;
margin: 0 !important;
padding: 16px 0 0 !important;
}

.plugin-detail-content > div {
width: 100%;
box-sizing: border-box;
border-radius: 0 !important;
box-shadow: none !important;
padding: 20px 16px !important;
}

.workflow-detail-hero {
grid-template-columns: minmax(0, 1fr) !important;
padding: 24px 16px !important;
}

.workflow-detail-tabs {
padding: 0 !important;
}

.workflow-detail-main {
padding: 18px 0 40px !important;
}

.hide-mobile {
display: none;
}
}

@media (min-width: 769px) {
.hide-desktop {
display: none;
}
}

/* Print Styles */
@media print {
body {
background: white;
}

.no-print {
display: none;
}
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;AACA,SAAS;AACT;;UAEU;AACV,mCAAmC;AACnC,kCAAkC;AAClC,yBAAyB;AACzB;;AAEA;AACA;SACS;AACT;;AAEA;AACA,iBAAiB;AACjB;;AAEA;EACE;IACE,wBAAwB;IACxB,0CAA0C;IAC1C,8BAA8B;IAC9B,yBAAyB;IACzB,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,8CAA8C;EAChD;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,0BAA0B;EAC5B;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,wBAAwB;IACxB,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,6BAA6B;IAC7B,8BAA8B;EAChC;AACF;;AAEA,sBAAsB;AACtB;AACA,WAAW;AACX,YAAY;AACZ;;AAEA;AACA,mBAAmB;AACnB;;AAEA;AACA,gBAAgB;AAChB,kBAAkB;AAClB;;AAEA;AACA,gBAAgB;AAChB;;AAEA,kBAAkB;;AAElB;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB;;AAEF,UAAU;AACV;AACA,cAAc;AACd,qBAAqB;AACrB,sBAAsB;AACtB;;AAEA;AACA,cAAc;AACd,0BAA0B;AAC1B;;AAEA,YAAY;AACZ;AACA,oBAAoB;AACpB,eAAe;AACf,oBAAoB;AACpB;;AAEA;AACA,YAAY;AACZ,2BAA2B;AAC3B;;AAEA;AACA,wBAAwB;AACxB;;AAEA;AACA,YAAY;AACZ,mBAAmB;AACnB;;AAEA,WAAW;AACX;;;AAGA,oBAAoB;AACpB,eAAe;AACf;;AAEA;;;AAGA,aAAa;AACb,qBAAqB;AACrB,8CAA8C;AAC9C;;AAEA,oBAAoB;AACpB;AACA,iBAAiB;AACjB,cAAc;AACd,aAAa;AACb;;AAEA;AACA,kBAAkB;AAClB;;AAEA;AACA,gBAAgB;AAChB;;AAEA;AACA,iBAAiB;AACjB;;AAEA,sBAAsB;AACtB,QAAQ,eAAe,EAAE;AACzB,QAAQ,gBAAgB,EAAE;AAC1B,QAAQ,gBAAgB,EAAE;AAC1B,QAAQ,gBAAgB,EAAE;AAC1B,QAAQ,gBAAgB,EAAE;;AAE1B,QAAQ,kBAAkB,EAAE;AAC5B,QAAQ,mBAAmB,EAAE;AAC7B,QAAQ,mBAAmB,EAAE;AAC7B,QAAQ,mBAAmB,EAAE;AAC7B,QAAQ,mBAAmB,EAAE;;AAE7B,QAAQ,gBAAgB,EAAE;AAC1B,QAAQ,iBAAiB,EAAE;AAC3B,QAAQ,iBAAiB,EAAE;;AAE3B,QAAQ,iBAAiB,EAAE;AAC3B,QAAQ,kBAAkB,EAAE;AAC5B,QAAQ,kBAAkB,EAAE;;AAE5B,OAAO,YAAY,EAAE;AACrB,OAAO,aAAa,EAAE;AACtB,OAAO,aAAa,EAAE;AACtB,OAAO,aAAa,EAAE;;AAEtB,QAAQ,gBAAgB,EAAE;AAC1B,QAAQ,iBAAiB,EAAE;AAC3B,QAAQ,iBAAiB,EAAE;;AAE3B,QAAQ,mBAAmB,EAAE;AAC7B,QAAQ,oBAAoB,EAAE;AAC9B,QAAQ,oBAAoB,EAAE;;AAE9B,sBAAsB;AACtB;AACA,aAAa;AACb;;AAEA;AACA,sBAAsB;AACtB;;AAEA;AACA,mBAAmB;AACnB;;AAEA;AACA,mBAAmB;AACnB;;AAEA;AACA,uBAAuB;AACvB;;AAEA;AACA,qBAAqB;AACrB;;AAEA;AACA,uBAAuB;AACvB;;AAEA;AACA,8BAA8B;AAC9B;;AAEA;AACA,6BAA6B;AAC7B;;AAEA;AACA,2BAA2B;AAC3B;;AAEA;AACA,yBAAyB;AACzB;;AAEA;AACA,eAAe;AACf;;AAEA;AACA,SAAO;AACP;;AAEA,SAAS,QAAQ,EAAE;AACnB,SAAS,SAAS,EAAE;AACpB,SAAS,SAAS,EAAE;AACpB,SAAS,SAAS,EAAE;;AAEpB,mBAAmB;AACnB;AACA,WAAW;AACX;;AAEA;AACA,YAAY;AACZ;;AAEA;AACA,WAAW;AACX;;AAEA;AACA,YAAY;AACZ;;AAEA,YAAY;AACZ;AACA,cAAc;AACd;;AAEA;AACA,qBAAqB;AACrB;;AAEA;AACA,aAAa;AACb;;AAEA,aAAa;AACb;AACA,kBAAkB;AAClB;;AAEA;AACA,kBAAkB;AAClB;;AAEA;AACA,eAAe;AACf;;AAEA,aAAa;AACb;AACA,cAAc;AACd;;AAEA;AACA,gBAAgB;AAChB;;AAEA,kBAAkB;AAClB;AACA,kBAAkB;AAClB;;AAEA;AACA,kBAAkB;AAClB;;AAEA;AACA,mBAAmB;AACnB;;AAEA;AACA,qBAAqB;AACrB;;AAEA,YAAY;AACZ;AACA,yCAAyC;AACzC;;AAEA;AACA,wCAAwC;AACxC;;AAEA;AACA,wCAAwC;AACxC;;AAEA;AACA,0CAA0C;AAC1C;;AAEA,SAAS;AACT;AACA,iBAAiB;AACjB;;AAEA;AACA,gBAAgB;AAChB;;AAEA;AACA,mBAAmB;AACnB;;AAEA;AACA,eAAe;AACf;;AAEA;AACA,eAAe;AACf;;AAEA;AACA,eAAe;AACf;;AAEA;AACA,eAAe;AACf;;AAEA;AACA,eAAe;AACf;;AAEA,WAAW;AACX;AACA,cAAc;AACd;;AAEA;AACA,cAAc;AACd;;AAEA;AACA,WAAW;AACX;;AAEA;AACA,WAAW;AACX;;AAEA;AACA,WAAW;AACX;;AAEA;AACA,yBAAyB;AACzB;;AAEA;AACA,yBAAyB;AACzB;;AAEA;AACA,sBAAsB;AACtB;;AAEA;AACA,yBAAyB;AACzB;;AAEA,eAAe;AACf;AACA;AACA,UAAU;AACV;AACA;AACA,UAAU;AACV;AACA;;AAEA;AACA;AACA,2BAA2B;AAC3B,UAAU;AACV;AACA;AACA,wBAAwB;AACxB,UAAU;AACV;AACA;;AAEA;AACA,8BAA8B;AAC9B;;AAEA;AACA,gCAAgC;AAChC;;AAEA,oBAAoB;AACpB;AACA,yBAAyB;AACzB,6BAA6B;AAC7B,kBAAkB;AAClB,WAAW;AACX,YAAY;AACZ,kCAAkC;AAClC;;AAEA;AACA,KAAK,uBAAuB,EAAE;AAC9B,OAAO,yBAAyB,EAAE;AAClC;;AAEA,eAAe;AACf;AACA;AACA,aAAa;AACb;;AAEA;AACA,wBAAwB;AACxB;;AAEA;AACA,6BAA6B;AAC7B;;AAEA;AACA,wBAAwB;AACxB,iCAAiC;AACjC,oBAAoB;AACpB,sBAAsB;AACtB;;AAEA;AACA,sBAAsB;AACtB,uBAAuB;AACvB;;AAEA;AACA,sBAAsB;AACtB;;AAEA;AACA,0BAA0B;AAC1B,gDAAgD;AAChD;;AAEA;AACA,sBAAsB;AACtB,0BAA0B;AAC1B,sBAAsB;AACtB,qBAAqB;AACrB,iBAAiB;AACjB,gBAAgB;AAChB,qBAAqB;AACrB;;AAEA;AACA,cAAc;AACd,6BAA6B;AAC7B,mBAAmB;AACnB;;AAEA;AACA,sBAAsB;AACtB,0BAA0B;AAC1B,sBAAsB;AACtB,oBAAoB;AACpB,4BAA4B;AAC5B;;AAEA;AACA,WAAW;AACX,sBAAsB;AACtB,2BAA2B;AAC3B,2BAA2B;AAC3B,6BAA6B;AAC7B;;AAEA;AACA,gDAAgD;AAChD,6BAA6B;AAC7B;;AAEA;AACA,qBAAqB;AACrB;;AAEA;AACA,+BAA+B;AAC/B;;AAEA;AACA,aAAa;AACb;AACA;;AAEA;AACA;AACA,aAAa;AACb;AACA;;AAEA,iBAAiB;AACjB;AACA;AACA,iBAAiB;AACjB;;AAEA;AACA,aAAa;AACb;AACA","sourcesContent":["body {\nmargin: 0;\nfont-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\nsans-serif;\n-webkit-font-smoothing: antialiased;\n-moz-osx-font-smoothing: grayscale;\nbackground-color: #f5f7fa;\n}\n\ncode {\nfont-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\nmonospace;\n}\n\n#root {\nmin-height: 100vh;\n}\n\n@media (max-width: 700px) {\n  .repository-header-content {\n    display: grid !important;\n    grid-template-columns: minmax(0, 1fr) auto;\n    align-items: center !important;\n    gap: 14px 12px !important;\n    padding: 0 16px !important;\n  }\n\n  .repository-brand {\n    grid-column: 1 / -1;\n    justify-self: start;\n    width: 100%;\n  }\n\n  .repository-logo-text {\n    min-width: 0;\n    white-space: nowrap;\n    font-size: clamp(21px, 6.5vw, 28px) !important;\n  }\n\n  .repository-search {\n    grid-column: 1;\n    min-width: 0;\n    width: 100%;\n    max-width: none !important;\n  }\n\n  .repository-search-input {\n    min-width: 0;\n    width: 100%;\n    box-sizing: border-box;\n  }\n\n  .repository-login-button {\n    grid-column: 2;\n    white-space: nowrap;\n  }\n}\n\n@media (max-width: 430px) {\n  .repository-header-content {\n    gap: 12px 8px !important;\n    padding: 0 12px !important;\n  }\n\n  .repository-search {\n    gap: 6px !important;\n  }\n\n  .repository-search button,\n  .repository-login-button {\n    padding-left: 14px !important;\n    padding-right: 14px !important;\n  }\n}\n\n/* Scrollbar Styling */\n::-webkit-scrollbar {\nwidth: 10px;\nheight: 10px;\n}\n\n::-webkit-scrollbar-track {\nbackground: #f1f1f1;\n}\n\n::-webkit-scrollbar-thumb {\nbackground: #888;\nborder-radius: 5px;\n}\n\n::-webkit-scrollbar-thumb:hover {\nbackground: #555;\n}\n\n/* Global Resets */\n\n- {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  }\n\n/* Links */\na {\ncolor: #667eea;\ntext-decoration: none;\ntransition: color 0.2s;\n}\n\na:hover {\ncolor: #764ba2;\ntext-decoration: underline;\n}\n\n/* Buttons */\nbutton {\nfont-family: inherit;\ncursor: pointer;\ntransition: all 0.2s;\n}\n\nbutton:hover:not(:disabled) {\nopacity: 0.9;\ntransform: translateY(-1px);\n}\n\nbutton:active:not(:disabled) {\ntransform: translateY(0);\n}\n\nbutton:disabled {\nopacity: 0.6;\ncursor: not-allowed;\n}\n\n/* Inputs */\ninput,\ntextarea,\nselect {\nfont-family: inherit;\nfont-size: 14px;\n}\n\ninput:focus,\ntextarea:focus,\nselect:focus {\noutline: none;\nborder-color: #667eea;\nbox-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n/* Utility Classes */\n.container {\nmax-width: 1400px;\nmargin: 0 auto;\npadding: 20px;\n}\n\n.text-center {\ntext-align: center;\n}\n\n.text-left {\ntext-align: left;\n}\n\n.text-right {\ntext-align: right;\n}\n\n/* Spacing Utilities */\n.mt-1 { margin-top: 8px; }\n.mt-2 { margin-top: 16px; }\n.mt-3 { margin-top: 24px; }\n.mt-4 { margin-top: 32px; }\n.mt-5 { margin-top: 40px; }\n\n.mb-1 { margin-bottom: 8px; }\n.mb-2 { margin-bottom: 16px; }\n.mb-3 { margin-bottom: 24px; }\n.mb-4 { margin-bottom: 32px; }\n.mb-5 { margin-bottom: 40px; }\n\n.ml-1 { margin-left: 8px; }\n.ml-2 { margin-left: 16px; }\n.ml-3 { margin-left: 24px; }\n\n.mr-1 { margin-right: 8px; }\n.mr-2 { margin-right: 16px; }\n.mr-3 { margin-right: 24px; }\n\n.p-1 { padding: 8px; }\n.p-2 { padding: 16px; }\n.p-3 { padding: 24px; }\n.p-4 { padding: 32px; }\n\n.pt-1 { padding-top: 8px; }\n.pt-2 { padding-top: 16px; }\n.pt-3 { padding-top: 24px; }\n\n.pb-1 { padding-bottom: 8px; }\n.pb-2 { padding-bottom: 16px; }\n.pb-3 { padding-bottom: 24px; }\n\n/* Flexbox Utilities */\n.flex {\ndisplay: flex;\n}\n\n.flex-col {\nflex-direction: column;\n}\n\n.flex-row {\nflex-direction: row;\n}\n\n.items-center {\nalign-items: center;\n}\n\n.items-start {\nalign-items: flex-start;\n}\n\n.items-end {\nalign-items: flex-end;\n}\n\n.justify-center {\njustify-content: center;\n}\n\n.justify-between {\njustify-content: space-between;\n}\n\n.justify-around {\njustify-content: space-around;\n}\n\n.justify-start {\njustify-content: flex-start;\n}\n\n.justify-end {\njustify-content: flex-end;\n}\n\n.flex-wrap {\nflex-wrap: wrap;\n}\n\n.flex-1 {\nflex: 1;\n}\n\n.gap-1 { gap: 8px; }\n.gap-2 { gap: 16px; }\n.gap-3 { gap: 24px; }\n.gap-4 { gap: 32px; }\n\n/* Width & Height */\n.w-full {\nwidth: 100%;\n}\n\n.h-full {\nheight: 100%;\n}\n\n.w-auto {\nwidth: auto;\n}\n\n.h-auto {\nheight: auto;\n}\n\n/* Display */\n.block {\ndisplay: block;\n}\n\n.inline-block {\ndisplay: inline-block;\n}\n\n.hidden {\ndisplay: none;\n}\n\n/* Position */\n.relative {\nposition: relative;\n}\n\n.absolute {\nposition: absolute;\n}\n\n.fixed {\nposition: fixed;\n}\n\n/* Overflow */\n.overflow-auto {\noverflow: auto;\n}\n\n.overflow-hidden {\noverflow: hidden;\n}\n\n/* Border Radius */\n.rounded {\nborder-radius: 4px;\n}\n\n.rounded-lg {\nborder-radius: 8px;\n}\n\n.rounded-xl {\nborder-radius: 12px;\n}\n\n.rounded-full {\nborder-radius: 9999px;\n}\n\n/* Shadows */\n.shadow-sm {\nbox-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.shadow {\nbox-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.shadow-md {\nbox-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.shadow-lg {\nbox-shadow: 0 10px 15px rgba(0, 0, 0, 0.1);\n}\n\n/* Text */\n.font-bold {\nfont-weight: bold;\n}\n\n.font-semibold {\nfont-weight: 600;\n}\n\n.font-normal {\nfont-weight: normal;\n}\n\n.text-sm {\nfont-size: 14px;\n}\n\n.text-base {\nfont-size: 16px;\n}\n\n.text-lg {\nfont-size: 18px;\n}\n\n.text-xl {\nfont-size: 20px;\n}\n\n.text-2xl {\nfont-size: 24px;\n}\n\n/* Colors */\n.text-primary {\ncolor: #667eea;\n}\n\n.text-secondary {\ncolor: #764ba2;\n}\n\n.text-gray {\ncolor: #666;\n}\n\n.text-dark {\ncolor: #333;\n}\n\n.text-white {\ncolor: #fff;\n}\n\n.bg-primary {\nbackground-color: #667eea;\n}\n\n.bg-secondary {\nbackground-color: #764ba2;\n}\n\n.bg-white {\nbackground-color: #fff;\n}\n\n.bg-gray-light {\nbackground-color: #f8f9fa;\n}\n\n/* Animations */\n@keyframes fadeIn {\nfrom {\nopacity: 0;\n}\nto {\nopacity: 1;\n}\n}\n\n@keyframes slideIn {\nfrom {\ntransform: translateY(20px);\nopacity: 0;\n}\nto {\ntransform: translateY(0);\nopacity: 1;\n}\n}\n\n.fade-in {\nanimation: fadeIn 0.3s ease-in;\n}\n\n.slide-in {\nanimation: slideIn 0.3s ease-out;\n}\n\n/* Loading Spinner */\n.spinner {\nborder: 4px solid #f3f3f3;\nborder-top: 4px solid #667eea;\nborder-radius: 50%;\nwidth: 40px;\nheight: 40px;\nanimation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n0% { transform: rotate(0deg); }\n100% { transform: rotate(360deg); }\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n.container {\npadding: 10px;\n}\n\n.plugin-detail-header {\npadding: 16px !important;\n}\n\n.plugin-detail-hero {\npadding: 24px 16px !important;\n}\n\n.plugin-detail-hero-content {\ndisplay: flex !important;\nflex-direction: column !important;\ngap: 24px !important;\nwidth: 100% !important;\n}\n\n.plugin-detail-actions {\nwidth: 100% !important;\nmin-width: 0 !important;\n}\n\n.plugin-detail-actions button {\nbox-sizing: border-box;\n}\n\n.plugin-detail-gallery {\npadding: 20px 0 !important;\ngrid-template-columns: minmax(0, 1fr) !important;\n}\n\n.plugin-detail-tabs {\nwidth: 100% !important;\nmax-width: none !important;\nbox-sizing: border-box;\npadding: 0 !important;\ngap: 0 !important;\noverflow-x: auto;\nscrollbar-width: thin;\n}\n\n.plugin-detail-tabs > button {\nflex: 1 0 auto;\npadding: 14px 18px !important;\nwhite-space: nowrap;\n}\n\n.plugin-detail-content {\nwidth: 100% !important;\nmax-width: none !important;\nbox-sizing: border-box;\nmargin: 0 !important;\npadding: 16px 0 0 !important;\n}\n\n.plugin-detail-content > div {\nwidth: 100%;\nbox-sizing: border-box;\nborder-radius: 0 !important;\nbox-shadow: none !important;\npadding: 20px 16px !important;\n}\n\n.workflow-detail-hero {\ngrid-template-columns: minmax(0, 1fr) !important;\npadding: 24px 16px !important;\n}\n\n.workflow-detail-tabs {\npadding: 0 !important;\n}\n\n.workflow-detail-main {\npadding: 18px 0 40px !important;\n}\n\n.hide-mobile {\ndisplay: none;\n}\n}\n\n@media (min-width: 769px) {\n.hide-desktop {\ndisplay: none;\n}\n}\n\n/* Print Styles */\n@media print {\nbody {\nbackground: white;\n}\n\n.no-print {\ndisplay: none;\n}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
